import NFT from './ABI/BattleGrowlies_metadata.json'


export default {
    BG: {ABI: NFT.output.abi, Address: "0x03081Efecb9357446947803bE3b1311130c40bcE"},
}
